import { render, staticRenderFns } from "./DpaPage.vue?vue&type=template&id=1424490e&"
import script from "./DpaPage.vue?vue&type=script&lang=js&"
export * from "./DpaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports